/** A per-voice tap keeps a character's face independent of other NPCs and broadcasts. */
export function createVoiceMeter(context: AudioContext, source: AudioNode, windowSize = 256) {
  const analyser = context.createAnalyser()
  analyser.fftSize = windowSize
  const samples = new Uint8Array(new ArrayBuffer(analyser.fftSize))
  source.connect(analyser)
  let disposed = false
  return {
    level(): number {
      if (disposed || context.state !== 'running') return 0
      analyser.getByteTimeDomainData(samples)
      let sum = 0
      for (const sample of samples) sum += ((sample - 128) / 128) ** 2
      return Math.min(1, Math.sqrt(sum / samples.length) * 3.2)
    },
    dispose(): void {
      if (disposed) return
      disposed = true
      try {
        source.disconnect(analyser)
      } catch {
        /* Source may already have ended. */
      }
      analyser.disconnect()
    },
  }
}
